export default __webpack_public_path__ + "static/media/80.b9edf00e.jpeg";